import React from 'react';
import reactCSS from 'reactcss';
import { CompactPicker } from 'react-color';

// import  { AlphaPicker, BlockPicker, ChromePicker, CirclePicker,
//  CompactPicker, GithubPicker, HuePicker, MaterialPicker, PhotoshopPicker, SketchPicker, SliderPicker,
//  SwatchesPicker, TwitterPicker } from 'react-color';

class ColorPicker extends React.Component {
  state = {
    displayColorPicker: false,
    color: this.props.color,
  };

  // presetColors = ['TRANSPARENT','#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF'];

  colors = ['TRANSPARENT', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E']

  componentDidUpdate(prevProps) {
    if (this.props.disabled && !prevProps.disabled) {
      this.setState({ displayColorPicker: false });
    }
  }

  handleClick = () => {
    if (this.props.disabled) {
      return;
    }
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChange = (color) => {
    if (this.props.disabled) {
      return;
    }
    this.setState({ color: color.hex });
    this.props.onChange(color);
  };

  render() {
    const { disabled } = this.props;

    const styles = reactCSS({
      default: {
        color: {
          width: '25px',
          height: '14px',
          borderRadius: '2px',
          background: this.state.color,
          // background: `rgba(${ this.state.color.r }, ${ this.state.color.g }, ${ this.state.color.b }, ${ this.state.color.a })`,
        },
        container: {
          position: 'relative'
        },
        swatch: {
          padding: '3px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: disabled ? 'not-allowed' : 'pointer',
          pointerEvents: disabled ? 'none' : 'auto',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });

    return (
      <div style={styles.container}>
        <div onClick={this.handleClick} style={styles.swatch}>
          <div style={styles.color} />
        </div>
        {!disabled && this.state.displayColorPicker ? (
          <div style={styles.popover}>
            <div onClick={this.handleClose} style={styles.cover} />
            <CompactPicker
              color={this.state.color}
              colors={this.colors}
              onChange={this.handleChange}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default ColorPicker;
